import TypographyText from "@/Components/Form/TypographyText";
import { FiCalendar } from "@/Components/Icons/Icons";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "exportShipmentBillPrintQcertNoorDAte",
            component: "textarea",
            label: "Initialize",
            actionText: "Q/Cert. No./Date",
            action: "initCert",
            height: 100,
            sx: {
              backgroundColor: "var(--gray-0)",
            },
          },
        ],
        row3: [
          {
            name: "exportShipmentBillPrintTypeOfShipment",
            label: "Type Of Shipment",
            options: [
              { label: "Outright Sale", value: "Outright" },
              { label: "Consignment Export", value: "Consignment Export" },
              { label: "Others", value: "Others" },
            ],
            placeholder: "Outright Sale",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
          },
        ],
        row4: [
          {
            name: "exportShipmentBillPrintSpecifyIfOther",
            label: "Specify,if Other",
            component: "text-field",
          },
        ],

        row5: [
          {
            name: "exportShipmentBillPrintPermissionNo",
            label: "Permission No.& Date",
            component: "text-field",
            width: "50%"

          },
          {
            name: "exportShipmentBillPrintPermissionDate",
            component: "dateselector",
            endIconName: FiCalendar,
            disabled: true,
            width: "50%",
            dependsOn: "exportShipmentBillPrintPermissionNo"

          },
        ],
        row6: [
          {
            name: "exportShipmentBillPrintExportUnder",
            label: "Export Under",
            component: "dropdown",
            options: [
              { label: "Deferred Credit", value: "Deferred Creditt" },
              { label: "Joint Ventures", value: "Joint Ventures" },
              { label: "Repee Credit", value: "Repee Credit" },
              { label: "Others", value: "Others" },
            ],
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
          },
        ],
        row7: [
          {
            name: "exportShipmentBillPrintSBHeading",
            label: "S/B Heading",
            component: "text-field",
          },
        ],
        row8: [
          {
            name: "exportShipmentBillPrintTextTobePrintedOnBottomSB",
            actionText: "Text to be Printed on S/B bottom area",
            component: "textarea",
            sx: {
              backgroundColor: "var(--gray-0)",
            },
            height: 200,
          },
        ],
      },
    },
    {
      column: "column1",
      columnWidth: "40%",
      rows: {
        row1: [
          {
            name: "exportShipmentBillPrintExportTradeControl",
            actionText: "Export Trade Control",
            component: "textarea", // this renders the <textarea>
            height: 150,
            sx: {
              backgroundColor: "var(--gray-0)",
            },
          },
        ],
      },
    },
  ]
};
